'use strict';

/**
 * Payload builders for edit-app.js's this.save() (App.prototype$patchAttributes
 * for an existing app, App.create for a new one). Kept as pure functions
 * (mirrors seed-template-defaults.js / edit-app-connect.js) so the payload
 * shape can be asserted in unit tests without instantiating the Angular
 * controller.
 */
function buildAppUpdatePayload(app) {
    app = app || {};

    return {
        name: app.name,
        data: app.data,
        settings: app.settings,
        integrationId: app.integrationId,
    };
}

function buildAppCreatePayload(app, appTemplate) {
    app = app || {};
    appTemplate = appTemplate || {};

    return {
        name: app.name,
        data: app.data,
        settings: app.settings,
        appTemplateId: appTemplate.id,
        integrationId: app.integrationId,
    };
}

var editAppSavePayload = {
    buildAppUpdatePayload: buildAppUpdatePayload,
    buildAppCreatePayload: buildAppCreatePayload,
};

if (typeof module !== 'undefined' && typeof exports !== 'undefined' && module.exports === exports) {
    module.exports = editAppSavePayload;
}

if (typeof angular !== 'undefined') {
    angular.module('rocket.components').value('editAppSavePayload', editAppSavePayload);
}
